import {
  CONTACT_US_ASSETS_URL,
  LANDING_SUB_ASSETS_URL,
  MERCHANT_SUPPORT_ASSETS_URL,
  NAV_FOOTER_ASSETS_URL,
} from "./Url";

export const contactusAssets = {
  indiaFlag: `${CONTACT_US_ASSETS_URL}/india_flag.png`,
  reportTick: `${LANDING_SUB_ASSETS_URL}/report_tick.svg`,
  logoIcon: `${NAV_FOOTER_ASSETS_URL}/Cashfree-Dark.svg`,
};

export const describeOptions = [
  {
    label: "I am Cashfree Merchant",
    value: "I am Cashfree Merchant",
  },
  {
    label: "Exploring Cashfree",
    value: "I am Exploring Cashfree",
  },
];
export const annualTurnOverOptions = [
  {
    label: "< 12 Lakh Annually",
    value: "1200000",
  },
  {
    label: "12.1 Lakh - 3 Cr Annually",
    value: "1210000",
  },
  {
    label: "3.1 Cr - 36 Cr Annually",
    value: "31000000",
  },
  {
    label: "36.1 Cr - 100 Cr Annually",
    value: "36100000",
  },
  {
    label: "> 100 Cr Annually",
    value: "1001000000",
  },
];
export const gstValueOptions = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];
export const productInterestedData = [
  {
    label: "Payment Gateway",
    value: "payment-gateway",
  },
  {
    label: "Make Payouts",
    value: "Payouts",
  },
  {
    label: "Verification Suite",
    value: "Bank Account, IFSC & UPI VPA Verification",
  },
  {
    label: "Cross Border Payments",
    value: "Global Payouts (Send money to India)",
  },
];

export const stats = [
  {
    id: 0,
    countUpProps: {
      value: 600000,
      suffix: "+",
      useIndianFormat: true,
    },
    desc: "Businesses served",
  },
  {
    id: 1,
    countUpProps: {
      value: 80,
      prefix: "USD ",
      suffix: "B+",
    },

    desc: "Processed annually",
  },
  {
    id: 2,
    countUpProps: {
      value: 600,
      suffix: "M+",
    },
    desc: "Bank accounts served",
  },
];

export const heroLogoData = [
  {
    id: 0,
    src: `${MERCHANT_SUPPORT_ASSETS_URL}/nykaa.png`,
    width: "181",
    height: "60",
    className: "max-w-[60px]",
    alt: "Nykaa",
  },
  {
    id: 1,
    src: `${MERCHANT_SUPPORT_ASSETS_URL}/livspace.png`,
    width: "319",
    height: "69",
    className: "max-w-[106px]",
    alt: "Livspace",
  },
  {
    id: 2,
    src: `${MERCHANT_SUPPORT_ASSETS_URL}/hdfc.png`,
    width: "301",
    height: "51",
    className: "max-w-[100px]",
    alt: "HDFC Bank",
  },
  {
    id: 3,
    src: `${MERCHANT_SUPPORT_ASSETS_URL}/ixigo.png`,
    width: "195",
    height: "95",
    className: "max-w-[64px]",
    alt: "ixigo",
  },
  {
    id: 4,
    src: `${MERCHANT_SUPPORT_ASSETS_URL}/bajaj-finserv.png`,
    width: "193",
    height: "53",
    className: "max-w-[64px]",
    alt: "bajaj finserv",
  },
  {
    id: 5,
    src: `${MERCHANT_SUPPORT_ASSETS_URL}/l&t.png`,
    width: "331",
    height: "60",
    className: "max-w-[110px]",
    alt: "L&T Financial Services",
  },
  {
    id: 6,
    src: `${MERCHANT_SUPPORT_ASSETS_URL}/dream11.png`,
    width: "211",
    height: "47",
    className: "max-w-[70px]",
    alt: "dream11",
  },
  {
    id: 7,
    src: `${MERCHANT_SUPPORT_ASSETS_URL}/bigbasket.png`,
    width: "328",
    height: "98",
    className: "max-w-[109px]",
    alt: "bigbasket",
  },
];
